"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var FinanceReconciliationPartnersListCtl_1 = require("../../ctl/FinanceReconciliationPartnersListCtl");
var FinanceReconciliationPartnersDetailExpander_1 = require("./FinanceReconciliationPartnersDetailExpander");
var FinanceReconciliationSubPartnersList = /** @class */ (function (_super) {
    __extends(FinanceReconciliationSubPartnersList, _super);
    function FinanceReconciliationSubPartnersList(props) {
        var _this = _super.call(this, props) || this;
        _this.data = new FinanceReconciliationPartnersListCtl_1.FinanceReconciliationPartnersListCtl(_this.props.errDialog);
        return _this;
    }
    FinanceReconciliationSubPartnersList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                //  dtFrom: data.dtFrom,
                //  dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: this.data.DATA.data,
            totalRows: 0,
            dtFormat: this.props.state.getDateTimeFormat(),
        }, function () {
            _this.loadData(_this.props);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    FinanceReconciliationSubPartnersList.prototype.componentWillUnmount = function () {
        this.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    FinanceReconciliationSubPartnersList.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps) {
            this.loadData(nextProps);
        }
    };
    FinanceReconciliationSubPartnersList.prototype.loadData = function (Props, onDone) {
        this.data.LoadDataByReconciliationPartnerList({
            usr_partner_reconciliation_partner_id: Props.record.key
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    FinanceReconciliationSubPartnersList.prototype.columns = function () {
        return [
            {
                title: 'Логин',
                dataIndex: this.data.dk_usr_partner_login,
                key: this.data.dk_usr_partner_login,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.usr_partner_login,
                        " [",
                        record.key,
                        "]"));
                }
            }, {
                title: 'Доход партнера',
                children: [{
                        title: 'С игроков',
                        dataIndex: this.data.dk_amount,
                        key: this.data.dk_amount,
                        width: 200,
                    }, {
                        title: 'С субагентов',
                        dataIndex: this.data.dk_amount_sub,
                        key: this.data.dk_amount_sub,
                        width: 200,
                    }, {
                        title: 'Текущий баланс',
                        dataIndex: this.data.dk_amount_before,
                        key: this.data.dk_amount_before,
                        width: 200,
                    }]
            }, {
                title: 'Выплаты сформированы',
                children: [{
                        title: 'По игрокам',
                        dataIndex: this.data.dk_usr_partner_flow_id_player,
                        key: this.data.dk_usr_partner_flow_id_player,
                        width: 100,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, UIUtils_1.UIUtils.bool2Str(record.usr_partner_flow_id_player > 0, "ДА", "НЕТ")));
                        }
                    }, {
                        title: 'По субагентам',
                        dataIndex: this.data.dk_usr_partner_flow_id_sub,
                        key: this.data.dk_usr_partner_flow_id_sub,
                        width: 100,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, UIUtils_1.UIUtils.bool2Str(record.usr_partner_flow_id_sub > 0, "ДА", "НЕТ")));
                        }
                    }, {
                        title: 'Сброс минуса',
                        dataIndex: this.data.dk_usr_partner_flow_id_sub,
                        key: this.data.dk_usr_partner_flow_id_sub,
                        width: 100,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, UIUtils_1.UIUtils.bool2Str(record.usr_partner_flow_id_reset > 0, "ДА", "НЕТ")));
                        }
                    }]
            }
        ];
    };
    ;
    /* private onPageChanged(Page: number, PageSize: number) {
         let _page = Page;
         if (PageSize != this.state.pageSize) {
             _page = 1;
         }
         this.setState({ pageNum: _page, pageSize: PageSize }, () => {
             this.loadData(this.props);
         });
     }*/
    FinanceReconciliationSubPartnersList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
    };
    /*private doCalculateRevShares() {
        let _dtFrom = moment().startOf('month');
        let _dtTo = moment().add(0, 'd').set('hour', 0).set('minute', 0).set('second', 0);
        //
        this.props.dlgCalculateRevShare
            .SetDateFrom(_dtFrom)
            .SetDateTo(_dtTo)
            .SetTitle("Расчет revshare")
            .SetOnYesClick((dFrom, dTo, ignoreStart) => {

                this.props.data.DoGenerateRevshare({

                    pprograms: this.props.PProgramsList,
                    allPPrograms: this.props.allPPrograms,

                    from_year: dFrom.get('year'),
                    from_month: dFrom.get('month') + 1,
                    from_day: dFrom.get('date'),

                    to_year: dTo.get('year'),
                    to_month: dTo.get('month') + 1,
                    to_day: dTo.get('date'),

                    is_ignore_start_date: ignoreStart

                }, (generatedCount) => {
                    notificationHelper.ShowTopRightNotification(<div>Расчет вознаграждений окончен! Сгенерировано [{generatedCount}] вознаграждений</div>);
                    if (generatedCount > 0) {
                        this.loadData(this.props);
                    }
                });

            })
            .Show();
    }*/
    FinanceReconciliationSubPartnersList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    // onChange: this.onPageChanged.bind(this),
                    // onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement(FinanceReconciliationPartnersDetailExpander_1.default, { state: _this.props.state, record: record, errDialog: _this.props.errDialog })));
                }, expandRowByClick: true, expandIcon: function (props) {
                    props.expandable = true;
                    if (props.expanded) {
                        return React.createElement("span", { className: "ant-table-row-expand-icon ant-table-row-expanded" }); //ant-table-row-expanded
                    }
                    else {
                        return React.createElement("span", { className: "ant-table-row-expand-icon ant-table-row-collapsed" }); //ant-table-row-expanded
                    }
                }, onExpand: function (expanded, record) {
                    //expanded
                }, scroll: { x: true } })));
    };
    return FinanceReconciliationSubPartnersList;
}(React.Component));
exports.default = FinanceReconciliationSubPartnersList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_reconciliations/ui/component/FinanceReconciliationSubPartnersList.tsx
// module id = 2557
// module chunks = 0